import fp from 'lodash/fp';
import React from 'react';
import { Breadcrumb, BreadcrumbItem } from "react-bootstrap";
import { connect } from 'react-redux';
import { LinkContainer } from "react-router-bootstrap";
import { branch, lifecycle, mapProps, renderComponent, withProps } from 'recompose';
import { bindActionCreators, compose } from 'redux';
import { routes } from '../../../../constants';
import { currentUserSelector, userActions } from '../../../../state/modules/user';
import Loading from '../../loading';
import ProgressReport from '../../shared/progress-report';

const reportBreadCrumb =
  <Breadcrumb>
    <LinkContainer to={routes.app.professionalProfile.root}>
      <BreadcrumbItem>
        Professional Profile
      </BreadcrumbItem>
    </LinkContainer>
    <BreadcrumbItem active>
      Progress Report
    </BreadcrumbItem>
  </Breadcrumb>

const mapStateToProps = (state) => ({
  user: currentUserSelector(state),
  report: state.user.snapshotReport
})

const mapDispatchToProps = (dispatch) => ({
  getUserReport: bindActionCreators(userActions.user.getSnapshotReport, dispatch)
})

export default compose(
  withProps(({
    match: {
      params: {
        snapshotId
      }
    }
  }) => ({
    snapshotId: parseInt(snapshotId, 10)
  })),
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentDidMount() {
      const {
        getUserReport,
        snapshotId
      } = this.props;

      getUserReport(snapshotId);
    }
  }),
  branch(
    ({ report }) => !report,
    renderComponent(Loading)
  ),
  mapProps(
    ({ report, user }) => ({
      afsLicence: report.afsLicence,
      cpdActivity: report.cpdActivity,
      cpdDaysRemaining: report.cpdDaysRemaining,
      user,
      cpdCategoryProgress: report.cpdCategoryProgress,
      defaultProgressLabel: fp.get('userIndustry.defaultProgressLabel')(report),
      filter: {
        fromDate: report.fromDate,
        toDate: report.toDate
      },
      reportBreadCrumb,
      goals: report.goals,
      trainingPlanSnapshot: report.snapshot
    })
  )
)(ProgressReport);


// WEBPACK FOOTER //
// ./src/containers/pages/app/professional-profile/user-snapshot-progress-report.js